module.exports = __webpack_public_path__ + "img/ideal.dee315ea.svg";